const Constants = require('EurestoFonction/Constants')
const Data = require('EurestoClass/Data')
const User = require('EurestoClass/User')

module.exports = (programme, fonction) => {
    if (User.default.User.get().type === Constants.default.access.EURESTO) return 1
    const profil = Data.default.get(Constants.default.module.CONFIGURATION, Constants.default.donnee.profil,
        { id: User.default.User.get().profil_v2_id })

    if (!profil) return 0

    const accesFonction = profil.droits && profil.droits.find((droit) => droit.programme === programme && droit.fonction === fonction);

    if ((!accesFonction && !profil.admin)
        || (accesFonction && (!profil.autorisation))) return 0


    return !accesFonction ? profil.niveau : (accesFonction.type === 1 ? 1234 : accesFonction.niveau)
}


// WEBPACK FOOTER //
// ./app/Utilitaire/Function/AllowFonction.js